module.exports = __webpack_public_path__ + "img/Send-Button.3453c730.svg";